import React from 'react';
import { List, ListItem, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

import Meta from '@bizapp-lp/workflow/organisms/Meta';
import Complete from '@bizapp-lp/workflow/templates/Complete';

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& .MuiListItem-root': {
        display: 'block',
        textAlign: 'center',
      },
    },
  }),
);

const Page: React.FC = () => {
  const classes = useStyle();
  return (
    <>
      <Meta>
        <title>Workflow 社内向けサイトマップ</title>
      </Meta>
      <Complete
        heading1="Workflow 社内向けサイトマップ"
        heading2="各ページ確認用"
        description=""
      >
        <Container className={classes.root}>
          <List>
            <ListItem>
              <Link component={RouterLink} to="/workflow/internal/old-home">
                旧Home(Landing Page)
              </Link>
            </ListItem>
          </List>
        </Container>
      </Complete>
    </>
  );
};

const Sitemap = React.memo(Page);
export default Sitemap;
